export const environment = {
  production: false,
  apiActivation: 'https://aktywacja.ekoemka.com.pl:64738',
  useCORSProxy: false,
  isPartnerVersion: false,
  isEmkaOilVersion: true,
  mobileAesIV: '',
  mobileAesKey: '',
};
